module.exports = __webpack_public_path__ + "/img/loading-grey.32acfae82a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/loading-grey.svg
// module id = 528
// module chunks = 0